import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/jenkins_workspace/angelai.com_workshop_nextjs/workshop-nextjs/node_modules/next/dist/client/app-dir/link.js");
